<template>
 <div class="ViewContent">
     <div class="introduce"  v-for="(it,index) in list"
      :key="index" :style="{'backgroundImage':it.img?'url(' + it.img + ')':'none','height':it.height ,'background-color':it.color?it.color:'transparent'}">
     <div class="introduce-content" :class="[it.type==='left'?'leftActive':'rightActive']">
        <p class="introduce-content-title" :style="{'color':it.fontColor?it.fontColor:'#fff'}">{{it.title}}</p>
        <p :style="{'width':it.width}">{{it.content}}</p>
        <p  :style="{'width':it.width}" v-if="it.content2">{{it.content2}}</p>
      </div>
  </div>
 </div>
</template>

<script>
export default {
props:{
    list:{
        type:Array
    }
}
}
</script>

<style scoped>
.leftActive{
padding-left:360px;
top: 0;
left: 0;
}
.rightActive{
     padding-left: 100px;

    top: 0;
right: 0;
}
.introduce{

  min-width: 1920px;

  position: relative;
  background-size: cover;
  }
  .introduce-content{
 
    width: 50%;
    font-family: Regular;
font-weight: 300;
font-size: 20px;
color: #838690;
line-height: 28px;
display: flex;
flex-direction: column;
justify-content: center;
height: 100%;
position: absolute;

  }
  .introduce-content-title{
    font-family: Medium;
font-weight: 500;
font-size: 30px;
color: #FFFFFF;
line-height: 42px;
/* width: 120px; */
margin-bottom: 20px;

  }
   .item-Content{
    width: 500px;
   }
</style>